import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService, BannerNotification } from 'app/shared/services/notificationService';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';

@Component({
  selector: 'app-banner-notification-manager',
  templateUrl: './banner-notification-manager.component.html',
  styleUrls: ['./banner-notification-manager.component.css']
})
export class BannerNotificationManagerComponent implements OnInit {

  public newNotification:string;
  public bannerList: Array<BannerNotification>;
  public bannerListLoading: boolean = false;

  constructor(
    private notificationService:NotificationService,
    private config: AppConfig,
    private snackBar: MatSnackBar
    ) { }

  ngOnInit(): void {
    this.getAdminBannerList();
  }

  getAdminBannerList() {
    this.bannerList = [];
    this.bannerListLoading = true;
    this.notificationService.GetAdminLatestNotifications().then(notifications => {
      this.bannerList = notifications;
      this.bannerListLoading = false;
    });
  }

  deleteBannerNotification(banner) {
    if(confirm(`Are you sure you want to delete: ${banner.Message} ?`)) {
      this.bannerListLoading = true;
      this.notificationService.DeleteBannerNotification(banner.id).then(res => {
        this.bannerListLoading = false;
        this.getAdminBannerList();
        EventAggregator.publish(EventList.bannerListRefresh, true);
      })
    }
  }

  publishBannerNotification(){
    if(! this.newNotification) { 
      this.snackBar.open('Please provide a message.', 'close',  {duration: 3000}); 
      return;
    }
    if(confirm(`Are you sure you want to publish the banner notification message ?`)){
    this.notificationService.CreateBannerNotification(this.newNotification).then(res => {
      this.snackBar.open('Notification Published.', 'close',  {duration: 3000});
      this.getAdminBannerList();
      this.newNotification = "";
    });
   }
  }
}
